var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getFlagSharedShowFlightSearchResults === false
    ? _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "travel-ideas" }, [
            _c("h1", { staticClass: "idea-title travel-ideas" }, [
              _vm._m(0),
              _vm._v(_vm._s(_vm.contentheadline[_vm.getCurrentLocale])),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "block" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "toggle-container with-image box",
                    attrs: {
                      id: "accordion3",
                      "data-image-animation-type": "zoomIn",
                      "data-image-animation-duration": "1",
                    },
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "panel style1" }, [
                      _c("h4", { staticClass: "panel-title" }, [
                        _c(
                          "a",
                          {
                            staticClass: "collapsed",
                            attrs: {
                              href: "#acc7",
                              "data-toggle": "collapse",
                              "data-parent": "#accordion3",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.furtherservices_seat[_vm.getCurrentLocale]
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "panel-collapse collapse",
                          attrs: { id: "acc7" },
                        },
                        [
                          _c("div", { staticClass: "panel-content" }, [
                            _c("p"),
                            _c("div", { staticClass: "intro box" }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.furtherservices_seat_headline[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ]),
                              _c("br"),
                              _vm._v(" "),
                              _c("div", { staticClass: "image-box style14" }, [
                                _c("article", { staticClass: "box" }, [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "details" }, [
                                    _c("h5", { staticClass: "box-title" }, [
                                      _vm._v("Comfort Seat"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "price-wrapper" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "price-per-unit" },
                                          [_vm._v("30,00 €")]
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(
                                          _vm._s(
                                            _vm
                                              .furtherservices_seat_comfortseat[
                                              _vm.getCurrentLocale
                                            ]
                                          ) +
                                            "\n                                                        "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("article", { staticClass: "box" }, [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "details" }, [
                                    _c("h5", { staticClass: "box-title" }, [
                                      _vm._v("Best Seat"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "price-wrapper" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "price-per-unit" },
                                          [_vm._v("20,00 €")]
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(
                                          _vm._s(
                                            _vm.furtherservices_seat_bestseat[
                                              _vm.getCurrentLocale
                                            ]
                                          ) +
                                            "\n                                                        "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm._m(4),
                                _vm._v(" "),
                                _c("article", { staticClass: "box" }, [
                                  _vm._m(5),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "details" }, [
                                    _c("h5", { staticClass: "box-title" }, [
                                      _vm._v("Exit Seat"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "price-wrapper" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "price-per-unit" },
                                          [_vm._v("30,00 €")]
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(
                                          _vm._s(
                                            _vm.furtherservices_seat_exitseat[
                                              _vm.getCurrentLocale
                                            ]
                                          ) +
                                            "\n                                                        "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "long-description" }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.furtherservices_seat_text1[
                                      _vm.getCurrentLocale
                                    ]
                                  ) + " "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticStyle: {
                                      "font-size": "15.9996px",
                                      color: "#D6254D",
                                    },
                                    attrs: {
                                      href: "/services",
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.furtherservices_seat_here[
                                          _vm.getCurrentLocale
                                        ]
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v("."),
                              ]),
                              _c("br"),
                              _vm._v(" "),
                              _c("h4", {
                                staticStyle: { color: "#D6254D" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.furtherservices_seat_text2[
                                      _vm.getCurrentLocale
                                    ]
                                  ),
                                },
                              }),
                              _c("br"),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.furtherservices_seat_text3[
                                      _vm.getCurrentLocale
                                    ]
                                  ) + " "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticStyle: {
                                      "font-size": "15.9996px",
                                      color: "#D6254D",
                                    },
                                    attrs: {
                                      href: "/infos-seat-reservation/#/seat-reservation",
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.furtherservices_seat_here[
                                          _vm.getCurrentLocale
                                        ]
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v("."),
                              ]),
                              _c("p"),
                            ]),
                            _vm._v(" "),
                            _c("p"),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "panel style1" }, [
                      _c("h4", { staticClass: "panel-title" }, [
                        _c(
                          "a",
                          {
                            staticClass: "collapsed",
                            attrs: {
                              href: "#acc8",
                              "data-toggle": "collapse",
                              "data-parent": "#accordion3",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.furtherservices_luggage[
                                  _vm.getCurrentLocale
                                ]
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "panel-collapse collapse",
                          attrs: { id: "acc8" },
                        },
                        [
                          _c("div", { staticClass: "panel-content" }, [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.luggage_text1[_vm.getCurrentLocale]
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.luggage_text2[_vm.getCurrentLocale]
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.luggage_text3[_vm.getCurrentLocale]
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.luggage_text3b[_vm.getCurrentLocale]
                                ) + " "
                              ),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "15.9996px",
                                    color: "#D6254D",
                                  },
                                  attrs: {
                                    href: "/infos-luggage/#/luggage",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.furtherservices_seat_here[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                              _vm._v("."),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.luggage_text4[_vm.getCurrentLocale]
                                ) + " "
                              ),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "15.9996px",
                                    color: "#D6254D",
                                  },
                                  attrs: {
                                    href: "/services",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.furtherservices_seat_here[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                              _vm._v("."),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.luggage_text5[_vm.getCurrentLocale]
                                ) + " "
                              ),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "15.9996px",
                                    color: "#D6254D",
                                  },
                                  attrs: {
                                    href: "/infos-additional-services/#/additional-services",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.furtherservices_seat_here[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                              _vm._v("."),
                            ]),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.luggage_textlistheader[
                                    _vm.getCurrentLocale
                                  ]
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("ul", { staticClass: "check-circle box" }, [
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.luggage_li1[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.luggage_li2[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.luggage_li3[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.luggage_textcontact[_vm.getCurrentLocale]
                                ),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "panel style1" }, [
                      _c("h4", { staticClass: "panel-title" }, [
                        _c(
                          "a",
                          {
                            staticClass: "collapsed",
                            attrs: {
                              href: "#acc9",
                              "data-toggle": "collapse",
                              "data-parent": "#accordion3",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.furtherservices_sportequipment[
                                  _vm.getCurrentLocale
                                ]
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "panel-collapse collapse",
                          attrs: { id: "acc9" },
                        },
                        [
                          _c("div", { staticClass: "panel-content" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.sportequipment_text1[_vm.getCurrentLocale]
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("ul", { staticClass: "check-circle box" }, [
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.sportequipment_li1[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.sportequipment_li2[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.sportequipment_li3[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.sportequipment_li4[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.sportequipment_li5[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.sportequipment_li6[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.sportequipment_li7[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.sportequipment_li8[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.sportequipment_li9[_vm.getCurrentLocale]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.sportequipment_li10[
                                      _vm.getCurrentLocale
                                    ]
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.sportequipment_text3[_vm.getCurrentLocale]
                                ) + " "
                              ),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "15.9996px",
                                    color: "#D6254D",
                                  },
                                  attrs: {
                                    href: "/infos-additional-services/#/additional-services",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.furtherservices_seat_here[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                              _vm._v("."),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.sportequipment_text4[_vm.getCurrentLocale]
                                ) + " "
                              ),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "15.9996px",
                                    color: "#D6254D",
                                  },
                                  attrs: {
                                    href: "/services",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.furtherservices_seat_here[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                              _vm._v("."),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "toggle-container with-image box",
                    attrs: {
                      id: "accordion4",
                      "data-image-animation-type": "zoomIn",
                      "data-image-animation-duration": "1",
                    },
                  },
                  [
                    _vm._m(6),
                    _vm._v(" "),
                    _c("div", { staticClass: "panel style1" }, [
                      _c("h4", { staticClass: "panel-title" }, [
                        _c(
                          "a",
                          {
                            staticClass: "collapsed",
                            attrs: {
                              href: "#acc11",
                              "data-toggle": "collapse",
                              "data-parent": "#accordion4",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.furtherservices_meal[_vm.getCurrentLocale]
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "panel-collapse collapse",
                          attrs: { id: "acc11" },
                        },
                        [
                          _c("div", { staticClass: "panel-content" }, [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.meal_text1[_vm.getCurrentLocale]
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.meal_text2[_vm.getCurrentLocale]) +
                                  " "
                              ),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "15.9996px",
                                    color: "#D6254D",
                                  },
                                  attrs: {
                                    href: "https://www.sundair.com/downloads/Sundair-Bord-Bistro_and_Travel-Value.pdf",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.furtherservices_seat_here[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                              _vm._v("."),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.meal_text3[_vm.getCurrentLocale]) +
                                  " "
                              ),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "15.9996px",
                                    color: "#D6254D",
                                  },
                                  attrs: {
                                    href: "/services",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.furtherservices_seat_here[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                              _vm._v("."),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "panel style1" }, [
                      _c("h4", { staticClass: "panel-title" }, [
                        _c(
                          "a",
                          {
                            staticClass: "collapsed",
                            attrs: {
                              href: "#acc12",
                              "data-toggle": "collapse",
                              "data-parent": "#accordion4",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.furtherservices_furtherservices[
                                  _vm.getCurrentLocale
                                ]
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "panel-collapse collapse",
                          attrs: { id: "acc12" },
                        },
                        [
                          _c("div", { staticClass: "panel-content" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.furtherservices_text1[
                                    _vm.getCurrentLocale
                                  ]
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("ul", { staticClass: "check-circle box" }, [
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.furtherservices_li1[
                                      _vm.getCurrentLocale
                                    ]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.furtherservices_li2[
                                      _vm.getCurrentLocale
                                    ]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.furtherservices_li3[
                                      _vm.getCurrentLocale
                                    ]
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("li", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.furtherservices_li4[
                                      _vm.getCurrentLocale
                                    ]
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.furtherservices_text2[
                                      _vm.getCurrentLocale
                                    ]
                                  ) +
                                  " "
                              ),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "15.9996px",
                                    color: "#D6254D",
                                  },
                                  attrs: {
                                    href: "/services",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.furtherservices_seat_here[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                              _vm._v("."),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.furtherservices_text3[
                                      _vm.getCurrentLocale
                                    ]
                                  ) +
                                  " "
                              ),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "15.9996px",
                                    color: "#D6254D",
                                  },
                                  attrs: {
                                    href: "/infos-additional-services/#/additional-services",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.furtherservices_seat_here[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ]
                              ),
                              _vm._v("."),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "image-container animated fadeIn",
        staticStyle: { "animation-duration": "3s", visibility: "visible" },
        attrs: {
          "data-animation-type": "fadeIn",
          "data-animation-duration": "3",
        },
      },
      [
        _c("img", {
          attrs: { src: "/res/images/travelextras/tabs03.png", alt: "img1" },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        staticStyle: { "background-color": "#FF6600" },
        attrs: {
          src: "/res/images/services/seats/types/seat1.png",
          alt: "",
          width: "30",
          heigth: "30",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        staticStyle: { "background-color": "#9900CC" },
        attrs: {
          src: "/res/images/services/seats/types/seat1.png",
          alt: "",
          width: "30",
          heigth: "30",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "box" }, [
      _c("figure", [
        _c("img", {
          staticStyle: { "background-color": "#22B14C" },
          attrs: {
            src: "/res/images/services/seats/types/seat1.png",
            alt: "",
            width: "30",
            heigth: "30",
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "details" }, [
        _c("h5", { staticClass: "box-title" }, [_vm._v("Standard Seat")]),
        _vm._v(" "),
        _c("label", { staticClass: "price-wrapper" }, [
          _c("span", { staticClass: "price-per-unit" }, [_vm._v("12,00 €")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        staticStyle: { "background-color": "#3399FF" },
        attrs: {
          src: "/res/images/services/seats/types/seat1.png",
          alt: "",
          width: "30",
          heigth: "30",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "image-container animated fadeIn",
        staticStyle: { "animation-duration": "3s", visibility: "visible" },
        attrs: {
          "data-animation-type": "fadeIn",
          "data-animation-duration": "3",
        },
      },
      [
        _c("img", {
          attrs: { src: "/res/images/travelextras/tabs02.png", alt: "img1" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }